module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/caret-89a0e1ead4eae99c9783d85f5dec1eed.svg";